module.exports = __webpack_public_path__ + "img/3f_r_excel@2x.2f7cf9cb.png";